import resolutions from '../constants/resolutions';

type productContainerStylesClasses = 'container';

const productContainerStyles: Record<
  productContainerStylesClasses,
  Record<string, any>
> = {
  container: {
    [`@media (min-width: ${resolutions.sm})`]: {
      padding: '15px 100px',
    },
    [`@media (min-width: ${resolutions.md})`]: {
      padding: '15px 200px',
    },
    marginBottom: '5rem',
  },
};

export default productContainerStyles;
